import { APIClient } from '@innerhive-internal/innerhive-api-client';

export interface IReferralInviteResponse {
    referralId: string;
    inviteeEmail: string;
    inviteeName?: string;
    sentAt: string;
    isExistingUser: boolean;
}

export class ReferralService {
    static inject = () => [APIClient];

    constructor(private apiClient: APIClient) {}

    sendInvite = async (params: {
        inviteeEmail: string;
        inviteeName?: string;
    }): Promise<IReferralInviteResponse> => {
        const response = await this.apiClient.post('/referrals/invite', params);
        return response;
    };
}
